import axios from "../http";
import { handleGetRequestParams } from '@/common/js/util'

class Logistics {
  //客户列表
  getCustomerData() {
    const url = "/oa/api/customer/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //快递列表
  getExpressData() {
    const url = "/oa/api/express/type/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取客户快递详情
  getExpressRuleList(projectId, expressType) {
    const url = `/oa/api/express/cus/rule?projectId=${projectId}&expressType=${expressType}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //现场定价保存
  postAddExpressMethod(data) {
    const url = "/oa/api/express/cus/rule/add/method";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //取整规则列表
  getRoundList() {
    const url = '/oa/api/express/roundType/list';
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 获取物流公司列表 */
  getLogisticsCompanyList() {
    const url = "/oa/api/logistic/company/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取服务关系列表 */
  getSerachList(option) {
    let url = "/oa/api/express/carrier/rule/base/info/list?";
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 保存物流公司 */
  postSaveLogistics(data) {
    const url = "/oa/api/logistic/company/save";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改物流公司 */
  postModLogistics(data) {
    const url = "/oa/api/logistic/company/update";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 映射列表 */
  getMappingList() {
    let url = "/oa/api/express/order/name/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除映射列表 */
  postDelMappingList(data) {
    let url = "/oa/api/express/order/name/delete";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除映射列表 */
  postSaveMappingList(data) {
    let url = "/oa/api/express/order/name/save";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 设置模板名称 */
  postSetTemplateName(data) {
    const url = "/oa/api/express/carrier/rule/base/info/set/template";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 模板列表  */
  postTemplateList(option) {
    let url = "/oa/api/express/carrier/rule/base/info/list/template?";
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改成本系数 */
  postModCostCoefficient(data) {
    const url = "/oa/api/express/carrier/rule/base/info/update/cost/coefficient";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Logistics;
